angular.module('tgaApp').run(['$templateCache', function($templateCache) {
  $templateCache.put('views/unauthorized.html',
    '<div class="form"> <div class="info-title" translate="scenarios.game.denied"></div> <div class="info-body" translate="scenarios.game.denied_info"></div> </div> ');
}]);
